import React, { useState } from 'react'
import { SwitchLabel } from './components/switch-label'
import { SwitchRefresh } from './components/switch-refresh'
import { SwitchToggle } from './components/switch-toggle'
import * as Comp from './switch.styles'
import type { TSwitchProps } from './types'

const SwitchRoot = ({
  onPress,
  disabled = false,
  value,
  children,
  testID,
}: TSwitchProps) => {
  const [pressed, setPressed] = useState(false)

  let renderLabel: null | React.ReactElement = null
  let renderRefresh: null | React.ReactElement = null

  React.Children.forEach(children, child => {
    if (!React.isValidElement(child)) return

    if (child.type === SwitchRefresh) {
      renderRefresh = React.cloneElement(
        child as React.ReactElement<TSwitchProps>
      )
    } else if (child.type === SwitchLabel && !renderRefresh) {
      renderLabel = React.cloneElement(
        child as React.ReactElement<TSwitchProps>,
        { disabled }
      )
    }
  })

  const componentProperties = {
    hasValue: value,
    hasPressed: pressed,
    hasDisabled: disabled,
    hasInternalRefresh: !!renderRefresh,
  }

  return (
    <Comp.Root
      testID={testID}
      {...componentProperties}
      onPress={() => {
        if (typeof onPress === 'function' && !disabled) {
          onPress()
        }
      }}
      disabled={disabled}
      onPressIn={() => setPressed(true)}
      onPressOut={() => setPressed(false)}
    >
      {renderRefresh || renderLabel}
      <Comp.Container {...componentProperties}>
        <SwitchToggle />
      </Comp.Container>
    </Comp.Root>
  )
}

export const Switch = {
  Root: SwitchRoot,
  Label: SwitchLabel,
  Refresh: SwitchRefresh,
}

export type { TSwitchProps }
